<template>
  <div id="CommodityDetail" style="background: white">
    <DetailHeader title="闪购详情" :is-nav="true"></DetailHeader>
    <div class="commodity-scroll">
      <Content :details="details" :commodityDetail="commodityDetail" :dataTable="dataList" @reload="reload"></Content>
    </div>
    <div class="commodity-bottom border-top">
      <div><van-icon name="service-o" /></div>
      <!-- <van-button type="danger" plain round v-if="details.status == '60' && detailsOps">{{ detailsOps }}</van-button> -->
      <!-- <van-button type="danger" plain round v-if="true || (!(details.status == '60') && !detailsOps)">请到电脑端参与</van-button> -->
      <div class="danger" v-if="details.status == '60' && detailsOps">{{ detailsOps }}</div>
      <div class="danger" v-if="true || (!(details.status == '60') && !detailsOps)">请到电脑端参与</div>
    </div>
  </div>
</template>

<script>
import DetailHeader from "@/components/Header";
import Content from "./components/Content";
import goodsApi from "@/request/goodsApi";
import { falshSaleDetails } from "@/request/flashSale-Api";
import { listButton } from "@/views/auction/auction-utils";
export default {
  name: "FlashSaleDetail",
  components: {
    DetailHeader,
    Content,
  },
  props: {
    id: String,
  },
  data() {
    return {
      dataList: [],
      LNGmaterialCode: this.$common.interfacePath.LngMaterialCode,
      PNGmaterialCode: this.$common.interfacePath.PngMaterialCode,
      choiceFlag: false,
      bidFlag: false,
      commodityDetail: "",
      details: {
        buttonStatus: {},
      },
    };
  },
  computed: {
    fsId() {
      return this.$route.query.fsId;
    },
    //参与（即将开始||竞拍中 &&  ）
    partIn() {
      return (
        (this.details.status == "30" || this.details.status == "40") &&
        this.details.paidDepositFlag == "00" &&
        this.details.depositWay == "00"
      );
    },
    detailsOps() {
      if (this.details.buttonStatus.winner) {
        return "已中标";
      }
      if (this.details.buttonStatus.failure) {
        return "未中标";
      }
      if (this.details.buttonStatus.failed) {
        return "已流标";
      }
      return "";
    },
  },
  mounted() {
    this.getDetailFront(); //查询竞拍详情
    this.getMyList();
  },
  methods: {
    // 请求
    async getMyList() {
      // let params = Object.assign({}, this.formPage, this.form);
      let params = { fsId: this.fsId };
      let res = await falshSaleDetails.listFlashSaleRecordPage(params);
      if (res.returnCode === "0") {
        res.result.dataList.forEach((element) => {
          element.createTime = this.$utils.formatDateTime(element.createTime);
          element.buyerName = this.$utils.formatName(element.buyerName);
        });
        this.dataList = res.result.dataList;
      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
    //刷新页面
    reload() {
      this.getDetailFront();
    },
    // 请求
    async getDetailFront() {
      let callback = (data) => {
        this.getCommodityById(data.commodityId);
      };
      let params = Object.assign({ fsId: this.fsId });
      let res = await falshSaleDetails.getFlashSaleBuyerById(params);
      if (res.returnCode === "0") {
        this.details = Object.assign({}, res.result, {
          buttonStatus: listButton(res.result),
        });
        console.log(this.details);
        callback(res.result);
      } else {
        this.$toast({
          type: "fail",
          message: res.returnMessage,
          duration: 1500,
        });
      }
    },
    getCommodityById(id) {
      let params = {
        id: id,
      };
      goodsApi.getCommodityById(params).then((res) => {
        if (res.returnCode == "0") {
          this.commodityDetail = res.result.introduction;
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>

<style lang='stylus' scoped>
#CommodityDetail >>> .van-popup {
  height: 75%;
  width: 100%;
}

#CommodityDetail {
  background-color: #f0f2f5;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .commodity-scroll {
    flex: 1;
    overflow: auto;
  }

  .commodity-bottom {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px;
    align-items: center;
    background: #fff;

    .danger {
      padding: 0 48px;
      height: 64px;
      line-height: 64px;
      text-align: center;
      background: #F6F7FA;
      border-radius: 40px 40px 40px 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #E0000C;
    }

    /deep/ .van-button {
      height: 70px;
      font-size: 28px;
      padding: 0 40px;
    }
  }
}
</style>
